module.exports = __webpack_public_path__ + "static/media/trainers.f3c27625.svg";